var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpworkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1059 285.2",
    style: {
      enableBackground: "new 0 0 1059 285.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#14A800;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.1,58.3c-46.8,0-73,30.5-80.5,61.9c-8.5-16-14.8-37.4-19.7-57.3h-64.7v80.5c0,29.2-13.3,50.8-39.3,50.8 S37,172.6,37,143.4l0.3-80.5H0v80.5c0,23.5,7.6,44.8,21.5,60c14.3,15.7,33.8,23.9,56.4,23.9c45,0,76.4-34.5,76.4-83.9V89.3 c4.7,17.8,15.9,52,37.3,82l-20,113.9h37.9l13.2-80.7c4.3,3.6,8.9,6.8,13.8,9.7c12.7,8,27.2,12.5,42.2,13c0,0,2.3,0.1,3.5,0.1 c46.4,0,83.3-35.9,83.3-84.4S328.5,58.3,282.1,58.3 M282.1,194.1c-28.7,0-47.7-22.2-53-30.8c6.8-54.4,26.7-71.6,53-71.6 c26,0,46.2,20.8,46.2,51.2C328.3,173.3,308.1,194.1,282.1,194.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M818,80.1V62.9h-36.6v159.3h37.1v-62.4c0-38.4,3.5-66,55-62.4V61C849.5,59.2,830.8,64.2,818,80.1"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "560.4,62.9 533.5,174.3 504.8,62.9 457.6,62.9 428.8,174.3 402,62.9 364.4,62.9 405.6,222.3  450.2,222.3 481.2,109.1 511.9,222.3 556.5,222.3 600.1,62.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M681.8,58.3c-46.7,0-83.3,36.2-83.3,84.6s36.6,84.3,83.3,84.3c46.4,0,83.3-35.9,83.3-84.3 S728.3,58.3,681.8,58.3 M681.8,194.2c-26.4,0-46.2-20.8-46.2-51.3s19.9-51.2,46.2-51.2c26,0,46.2,20.8,46.2,51.2 S707.8,194.2,681.8,194.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M926.7,143.9h8.6l51.8,78.4h41.9l-59.6-86.9c28.9-11.3,48.3-40.8,48.3-72.5h-37c0,34.4-27.1,47.4-54,47.4V0 h-37.2v222.3h37.1L926.7,143.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1028.2,0v3.2h4.5v11.3h3.5V3.2h4.5V0H1028.2z M1054,0l-3.2,9.9h-0.1l-3.1-9.9h-4.9v14.5h3.3V4.1h0.1l3.1,10.4 h3l3.2-10.4h0.1v10.4h3.4V0H1054z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpworkLogo);
export default __webpack_public_path__ + "static/media/Upwork_Logo.ae522f9d697996bca3181e211c39777f.svg";
export { ForwardRef as ReactComponent };